import React, { PureComponent } from 'react';
import classNames from 'classnames';
import omit from 'lodash/omit';
import isNumber from 'lodash/isNumber';
import Icon from '../icon';
import { matchMediaPolifill } from '../_util/mediaQueryListPolyfill';
import LayoutContext from './LayoutContext';
import { LayoutSiderContextProvider } from './LayoutSiderContext';
if (typeof window !== 'undefined') {
    // const matchMediaPolyfill = (mediaQuery: string): MediaQueryList => {
    //   return {
    //     media: mediaQuery,
    //     matches: false,
    //     addListener() {
    //     },
    //     removeListener() {
    //     },
    //   };
    // };
    window.matchMedia = window.matchMedia || matchMediaPolifill;
}
const dimensionMap = {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1600px',
};
const generateId = (() => {
    let i = 0;
    return (prefix = '') => {
        i += 1;
        return `${prefix}${i}`;
    };
})();
export default class Sider extends PureComponent {
    constructor(props, context) {
        super(props, context);
        this.responsiveHandler = (event) => {
            this.setState({ below: event.matches });
            const { onBreakpoint } = this.props;
            if (onBreakpoint) {
                onBreakpoint(event.matches);
            }
            const { collapsed } = this.state;
            if (collapsed !== event.matches) {
                this.setCollapsed(event.matches, 'responsive');
            }
        };
        this.setCollapsed = (collapsed, type) => {
            if (!('collapsed' in this.props)) {
                this.setState({
                    collapsed,
                });
            }
            const { onCollapse } = this.props;
            if (onCollapse) {
                onCollapse(collapsed, type);
            }
        };
        this.toggle = () => {
            const { collapsed } = this.state;
            this.setCollapsed(!collapsed, 'clickTrigger');
        };
        this.belowShowChange = () => {
            const { belowShow } = this.state;
            this.setState({ belowShow: !belowShow });
        };
        const { getPrefixCls } = context;
        this.uniqueId = generateId(getPrefixCls('sider-'));
        let matchMedia;
        if (typeof window !== 'undefined') {
            matchMedia = window.matchMedia;
        }
        if (matchMedia && props.breakpoint && props.breakpoint in dimensionMap) {
            this.mql = matchMedia(`(max-width: ${dimensionMap[props.breakpoint]})`);
        }
        let collapsed;
        if ('collapsed' in props) {
            collapsed = props.collapsed;
        }
        else {
            collapsed = props.defaultCollapsed;
        }
        this.state = {
            collapsed,
            below: false,
        };
    }
    static get contextType() {
        return LayoutContext;
    }
    getContextValue() {
        const { collapsedWidth } = this.props;
        const { collapsed } = this.state;
        return {
            siderCollapsed: collapsed,
            collapsedWidth,
        };
    }
    componentWillReceiveProps(nextProps) {
        if ('collapsed' in nextProps) {
            this.setState({
                collapsed: nextProps.collapsed,
            });
        }
    }
    componentDidMount() {
        if (this.mql) {
            this.mql.addListener(this.responsiveHandler);
            this.responsiveHandler(new MediaQueryListEvent('change', {
                matches: this.mql.matches,
                media: this.mql.media,
            }));
        }
        const { siderHook } = this.context;
        if (siderHook) {
            siderHook.addSider(this.uniqueId);
        }
    }
    componentWillUnmount() {
        if (this.mql) {
            this.mql.removeListener(this.responsiveHandler);
        }
        const { siderHook } = this.context;
        if (siderHook) {
            siderHook.removeSider(this.uniqueId);
        }
    }
    render() {
        const { prefixCls: customizePrefixCls, className, theme, collapsible, reverseArrow, trigger, style, width, collapsedWidth, children, ...others } = this.props;
        const { collapsed, below } = this.state;
        const { getPrefixCls } = this.context;
        const prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
        const divProps = omit(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint', 'onBreakpoint']);
        const rawWidth = collapsed ? collapsedWidth : width;
        // use "px" as fallback unit for width
        const siderWidth = isNumber(rawWidth) ? `${rawWidth}px` : String(rawWidth);
        // special trigger when collapsedWidth == 0
        const zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? (React.createElement("span", { onClick: this.toggle, className: `${prefixCls}-zero-width-trigger` },
            React.createElement(Icon, { type: "bars" }))) : null;
        const iconObj = {
            expanded: reverseArrow ? React.createElement(Icon, { type: "right" }) : React.createElement(Icon, { type: "left" }),
            collapsed: reverseArrow ? React.createElement(Icon, { type: "left" }) : React.createElement(Icon, { type: "right" }),
        };
        const status = collapsed ? 'collapsed' : 'expanded';
        const defaultTrigger = iconObj[status];
        const triggerDom = trigger !== null ? zeroWidthTrigger || (React.createElement("div", { className: `${prefixCls}-trigger`, onClick: this.toggle, style: { width: siderWidth } }, trigger || defaultTrigger)) : null;
        const divStyle = {
            ...style,
            flex: `0 0 ${siderWidth}`,
            maxWidth: siderWidth,
            minWidth: siderWidth,
            width: siderWidth,
        };
        const siderCls = classNames(className, prefixCls, `${prefixCls}-${theme}`, {
            [`${prefixCls}-collapsed`]: !!collapsed,
            [`${prefixCls}-has-trigger`]: collapsible && trigger !== null && !zeroWidthTrigger,
            [`${prefixCls}-below`]: !!below,
            [`${prefixCls}-zero-width`]: parseFloat(siderWidth) === 0,
        });
        return (React.createElement(LayoutSiderContextProvider, Object.assign({}, this.getContextValue(), { getPrefixCls: getPrefixCls }),
            React.createElement("div", Object.assign({ className: siderCls }, divProps, { style: divStyle }),
                React.createElement("div", { className: `${prefixCls}-children` }, children),
                collapsible || (below && zeroWidthTrigger) ? triggerDom : null)));
    }
}
Sider.displayName = 'LayoutSider';
Sider.__C7N_LAYOUT_SIDER = true;
Sider.defaultProps = {
    collapsible: false,
    defaultCollapsed: false,
    reverseArrow: false,
    width: 200,
    collapsedWidth: 80,
    style: {},
    theme: 'dark',
};
